import { render, staticRenderFns } from "./PagePassword.vue?vue&type=template&id=6a40a0c1&"
import script from "./PagePassword.vue?vue&type=script&lang=js&"
export * from "./PagePassword.vue?vue&type=script&lang=js&"
import style0 from "./PagePassword.vue?vue&type=style&index=0&id=6a40a0c1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports